import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/ueber-uns/sections/InfoBoxes.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ueber-uns/UeberUns.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/common/Common.css");
